
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"52","height":"52","rx":"26","fill":"#F0F4FA"}}),_c('path',{attrs:{"d":"M26 35.825c5.426 0 9.825-4.399 9.825-9.825 0-5.426-4.4-9.824-9.825-9.824-5.426 0-9.825 4.398-9.825 9.824s4.399 9.825 9.825 9.825z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M28.754 21.162c-.637 0-1.222.202-1.737.6A3.959 3.959 0 0026 22.986a3.957 3.957 0 00-1.017-1.222c-.515-.399-1.1-.6-1.737-.6-1.78 0-3.122 1.455-3.122 3.385 0 2.085 1.674 3.512 4.209 5.672.43.367.918.783 1.425 1.226a.366.366 0 00.484 0c.507-.443.995-.86 1.425-1.226 2.535-2.16 4.209-3.587 4.209-5.672 0-1.93-1.342-3.386-3.122-3.386z","fill":"#fff"}})])
          )
        }
      }
    